"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var taxIdsValidationList = {
  id_npwp: '^([0-9]{2}.[0-9]{3}.[0-9]{3}.[0-9]{1}-[0-9]{3}.[0-9]{3})$',
  br_cnpj: '^([0-9]{2}.[0-9]{3}.[0-9]{3}/[0-9]{4}-[0-9]{2})$',
  ch_vat: '^([A-Z]{3}-[0-9]{3}.[0-9]{3}.[0-9]{3} [A-Z]{4})$',
  br_cpf: '^([0-9]{3}.[0-9]{3}.[0-9]{3}-[0-9]{2})$',
  cl_tin: '^([0-9]{2}.[0-9]{3}.[0-9]{3}-[A-Z]{1})$',
  my_sst: '^([A-Z0-9]{3}-[0-9]{4}-[0-9]{8})$',
  kr_brn: '^([0-9]{3}-[0-9]{2}-[0-9]{5})$',
  sg_gst: '^([A-Z]{1}[0-9]{8}[A-Z]{1})$',
  my_itn: '^([A-Z]{1} [0-9]{10})$',
  us_ein: '^([0-9]{2}-[0-9]{7})$',
  li_uid: '^([A-Z]{3}[0-9]{9})$',
  es_cif: '^([A-Z]{1}[0-9]{8})$',
  sg_uen: '^([0-9]{9}[A-Z]{1})$',
  no_vat: '^([0-9]{9}[A-Z]{3})$',
  in_gst: '^([A-Z0-9]{15})$',
  mx_rfc: '^([A-Z0-9]{12})$',
  ca_qst: '^([A-Z0-9]{9})$',
  ae_trn: '^([0-9]{15})$',
  sa_vat: '^([0-9]{15})$',
  jp_cn: '^([0-9]{13})$',
  th_vat: '^([0-9]{13})$',
  au_abn: '^([0-9]{11})$',
  ru_inn: '^([0-9]{10})$',
  za_vat: '^([0-9]{10})$',
  ca_bn: '^([0-9]{9})$',
  ru_kpp: '^([0-9]{9})$',
  nz_gst: '^([0-9]{9})$',
  hk_br: '^([0-9]{8})$',
  tw_vat: '^([0-9]{8})$',
  my_frp: '^([0-9]{8})$',
  jp_rn: '^([0-9]{5})$',
  eu_vat: '^((AT)?U[0-9]{8}|(BE)?0[0-9]{9}|(BG)?[0-9]{9,10}|(CY)?[0-9]{8}L|(CZ)?[0-9]{8,10}|(DE)?[0-9]{9}|(DK)?[0-9]{8}|(EE)?[0-9]{9}|(EL|GR)?[0-9]{9}|(ES)?[0-9A-Z][0-9]{7}[0-9A-Z]|(FI)?[0-9]{8}|(FR)?[0-9A-Z]{2}[0-9]{9}|(GB)?([0-9]{9}([0-9]{3})?|[A-Z]{2}[0-9]{3})|(HU)?[0-9]{8}|(IE)?[0-9]S[0-9]{5}L|(IT)?[0-9]{11}|(LT)?([0-9]{9}|[0-9]{12})|(LU)?[0-9]{8}|(LV)?[0-9]{11}|(MT)?[0-9]{8}|(NL)?[0-9]{9}B[0-9]{2}|(PL)?[0-9]{10}|(PT)?[0-9]{9}|(RO)?[0-9]{2,10}|(SE)?[0-9]{12}|(SI)?[0-9]{8}|(SK)?[0-9]{10})$'
};

var isTaxIdsValid = function isTaxIdsValid(_ref) {
  var taxIds = _ref.taxIds;
  var isTaxIdValid = Object.keys(taxIds).some(function (taxId) {
    if (taxIdsValidationList[taxId]) {
      var regex = new RegExp(taxIdsValidationList[taxId]);
      return regex.test(taxIds[taxId]);
    }

    return false;
  });
  return isTaxIdValid;
};

var _default = isTaxIdsValid;
exports["default"] = _default;
//# sourceMappingURL=isTaxIdsValid.js.map